module.exports = __webpack_public_path__ + "img/5.1599cd66.jpg";